import { useMutation } from 'react-query';
import {
  createRecognitionGroupAsync,
  deleteRecognitionGroupAsync,
  getAllRecognitionGroupByLicenseAsync,
  getAllRecognitionGroupByLicenseCountAsync,
  getRecognitionGroupByIdAsync,
  updateRecognitionGroupAsync,
} from '../../index';

export const useCreateRecognitionGroupAsync = () =>
  useMutation(createRecognitionGroupAsync);

export const useUpdateRecognitionGroupAsync = () =>
  useMutation(updateRecognitionGroupAsync);

export const useDeleteRecognitionGroupAsync = () =>
  useMutation(deleteRecognitionGroupAsync);

export const useGetRecognitionGroupAsync = () =>
  useMutation(getRecognitionGroupByIdAsync);

export const useGetAllRecognitionGroupByLicenseAsync = () =>
  useMutation(getAllRecognitionGroupByLicenseAsync);

export const useGetAllRecognitionGroupByLicenseCountAsync = () =>
  useMutation(getAllRecognitionGroupByLicenseCountAsync);
